import { render, staticRenderFns } from "./similarProducts.vue?vue&type=template&id=74af4d91"
import script from "./similarProducts.vue?vue&type=script&lang=js"
export * from "./similarProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports